// Reports whether the viewport is at or above Bootstrap's `md` breakpoint
// (768px). Subscribes to `change` events on the underlying `MediaQueryList`
// so layout flips correctly when the user rotates an iPhone or resizes a
// browser window.
//
// Defaults to `false` (i.e. mobile) before mount so layouts that toggle on
// this hook never flash a desktop-sized table on a phone-sized viewport.

import { useEffect, useState } from 'react';

const MD_QUERY = '(min-width: 768px)';

function readInitial() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia(MD_QUERY).matches;
}

export function useIsMdUp() {
  const [isMdUp, setIsMdUp] = useState(readInitial);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }
    const mql = window.matchMedia(MD_QUERY);
    const handler = (event) => setIsMdUp(event.matches);
    setIsMdUp(mql.matches);

    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, []);

  return isMdUp;
}
